import { Button } from './Button';

/**
 * Navegacao entre paginas.
 *
 * Mostra a faixa em exibicao e o total. Um controle com apenas "anterior" e
 * "proxima" esconde o tamanho do conjunto, que costuma ser a informacao que decide
 * se vale refinar o filtro.
 */
export function Pagination({
  total,
  limit,
  offset,
  onChange,
}: {
  total: number;
  limit: number;
  offset: number;
  onChange: (offset: number) => void;
}) {
  if (total <= limit) return null;

  const primeiro = offset + 1;
  const ultimo = Math.min(offset + limit, total);

  return (
    <div className="flex items-center justify-between gap-4 border-t border-line px-5 py-3">
      <p className="text-xs text-ink-500">
        <span className="font-medium text-ink-700">
          {primeiro} a {ultimo}
        </span>{' '}
        de {total}
      </p>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="secondary"
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - limit))}
        >
          Anterior
        </Button>
        <Button
          size="sm"
          variant="secondary"
          disabled={ultimo >= total}
          onClick={() => onChange(offset + limit)}
        >
          Proxima
        </Button>
      </div>
    </div>
  );
}
